<template>
  <div
    class="columns"
    :class="{
      categorized: categoriesList.length > 1,
    }"
  >
    <template v-for="category in filteredCategories">
      <div
        :key="category"
        class="category"
        :class="{
          opened: columnsData[category].opened,
        }"
      >
        <div class="category-title">
          <column
            :name="columnsData[category].fullName"
            :checked="isCategorySelected(category)"
            @toggle="toggleCategory(category, $event)"
          ></column>

          <svg-icon
            name="chevron-top-circled"
            class="category-toggler"
            color="primary"
            :size="24"
            @click="$set(columnsData[category], 'opened', !columnsData[category].opened)"
          ></svg-icon>
        </div>
        
        <transition name="slide">
          <div v-show="columnsData[category].opened" class="category-content">
            <div class="category-items">
              <template v-for="column in categories[category]">
                <template v-if="isVisibleColumn(column)">
                  {{ column.disabled }}
                  <column
                    :key="column"
                    :disabled="columnsData[column].disabled || (blockedColumns && blockedColumns.includes(column))"
                    :name="columnsData[column].formatLabel || columnsData[column].fullName"
                    :checked="isColumnSelected(column)"
                    @toggle="toggleColumn(column, $event)"
                  ></column>
                </template>
              </template>
            </div>
          </div>
        </transition>
      </div>
    </template>

    <div v-if="!filteredCategories.length" class="columns-empty">Ничего не найдено</div>
  </div>
</template>

<script>
import SvgIcon from "@/components/svg-icon";
import Column from "./column";

export default {
  components: { SvgIcon, Column },
  props: ["columns", "value", "filter", "blockedColumns"],
  computed: {
    normalizedFilter() {
      return this.filter.trim().toLowerCase();
    },

    // данные колонок и категорий
    columnsData() {
      const list = {
        other: {
          fullName: "Прочее",
        },
      };
      this.columns.forEach((c) => {
        list[c.id] = c;

        list[c.id].formatLabel = list[c.id].parentColumnId === 'transactionTypesGroup' ? `<span style='color: ${list[c.id].id.indexOf('withdraw') !== -1 ? '#ff238d' : '#12c971'}'>${list[c.id].shortName}</span> ${list[c.id].fullName}` : null
      });

      return list;
    },

    // id категорий
    categoriesList() {
      let categories = this.columns.filter((c) => c.isCategory);
      categories.sort((a, b) => a.sort - b.sort);
      categories = categories.map((c) => c.id);
      return [...categories, "other"];
    },

    // отсортированные колонки без категорий
    columnsWithoutCategory() {
      const list = this.columns.filter((c) => !c.isCategory && !c.parentColumnId);
      list.sort((a, b) => a.sort - b.sort);
      return list.map((c) => c.id);
    },

    // отсортированные колонки по категориям
    categories() {
      const categories = {};
      this.categoriesList.forEach((c) => {
        categories[c] = [];
      });

      this.columns.forEach((c) => {
        if (!c.isCategory && c.parentColumnId) {
          categories[c.parentColumnId].push(c);
        }
      });

      Object.keys(categories).forEach((category) => {
        const columns = categories[category];
        columns.sort((a, b) => a.sort - b.sort);
        categories[category] = columns.map((c) => c.id);
      });

      return {
        ...categories,
        other: this.columnsWithoutCategory,
      };
    },

    filteredCategories() {
      return this.categoriesList.filter((cId) => this.isVisibleCategory(cId));
    },
  },
  methods: {
    isColumnSelected(column) {
      return this.value.includes(column) ? 1 : 0;
    },

    isCategorySelected(category) {
      const columns = this.categories[category];
      const selected = columns.filter((cId) => this.isColumnSelected(cId));
      if (selected.length === columns.length) return 1;
      if (!selected.length) return 0;
      return 2;
    },

    isVisibleColumn(cId) {
      if (!this.normalizedFilter) return true;
      return this.columnsData[cId].fullName.toLowerCase().includes(this.normalizedFilter);
    },

    isVisibleCategory(cId) {
      const columns = this.categories[cId];
      if (!columns.length) return false;
      if (!this.normalizedFilter) return true;
      // if (this.isVisibleColumn(cId)) return true;
      return columns.some((column) => this.isVisibleColumn(column));
    },

    toggleColumn(column, checked) {
      let selected = [];

      if (!checked) {
        selected = this.value.filter((cId) => cId !== column);
      } else {
        selected = [...this.value, column];
      }
      this.$emit("input", selected);
    },

    toggleCategory(category, checked) {
      const columns = this.categories[category];
      let selected = [];

      if (checked) {
        selected = new Set([...this.value, ...columns]);
      } else {
        selected = new Set(this.value);
        columns.forEach((cId) => selected.delete(cId));
      }

      this.$emit("input", [...selected]);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.columns {
  .category-title {
    display: none;
  }

  .category-toggler {
    margin-left: auto;
    margin-right: 20px;
    flex-shrink: 0;
    transition: transform 250ms ease-in-out;
  }

  &-empty {
    // color: $color-label;
    font-size: 14px;
  }

  &.categorized {
    .category-title {
      display: flex;

      & /deep/ .item-label {
        font-size: 13px;
        font-weight: 500;
        color: $color-label;
      }
    }
    .category-items {
      padding-left: 30px;
    }
  }

  &:not(.categorized) {
    .category-content {
      display: block !important;
    }
  }

  .category.opened {
    .category-toggler {
      transform: rotate(-180deg);
    }
  }

  @media screen and (min-width: 768px) {
    .category-toggler {
      display: none;
    }
    .category-content {
      display: block !important;
    }
  }
}
</style>
